$(document).ready(function () {

  let galleryItems = [];

  function buildGallery() {
    galleryItems = [];

    let jsonEl = document.getElementById('product-media-json');
    if (!jsonEl) return;

    let mediaData = JSON.parse(jsonEl.textContent);

    mediaData.forEach(function (item) {
      if (item.media_type === "image") {

        let imgSrc = item.preview_image.src;

        if (imgSrc.indexOf('http') === -1) {
          imgSrc = 'https:' + imgSrc;
        }

        galleryItems.push({
          src: imgSrc,
          type: "image"
        });
      }
    });
  }

  // ✅ INSTANT LOAD
  buildGallery();

  // Variant change (light delay only when needed)
  $(document).on('change', 'select[name="id"]', function () {
    setTimeout(buildGallery, 200);
  });

  // Click event
  $(document).on('click', '.product-single__image-wrapper img, .product__media img', function (e) {
    e.preventDefault();

    if (typeof Fancybox === "undefined") return;

    let clickedSrc = $(this).attr('src') || '';

    let index = galleryItems.findIndex(item =>
      clickedSrc.includes(item.src.split('/').pop())
    );

    Fancybox.show(galleryItems, {
      startIndex: index >= 0 ? index : 0,
      Thumbs: { autoStart: true },
      Toolbar: {
        display: ["zoom", "slideShow", "fullscreen", "close"]
      }
    });
  });

});